// assets/drifter.js
(function () {
  function initCard(card) {
    if (!card || card.dataset.drifterInited === "true") return;
    card.dataset.drifterInited = "true";

    const stars = Array.from(card.querySelectorAll(".drifter-star"));
    if (!stars.length) return;

    const state = {
      mx: 0,
      my: 0,
      t: 0
    };

    function initStarPositions() {
      const cardRect = card.getBoundingClientRect();
      stars.forEach((star) => {
        const rect = star.getBoundingClientRect();
        const baseX = rect.left - cardRect.left;
        const baseY = rect.top - cardRect.top;
        star.dataset.baseX = baseX;
        star.dataset.baseY = baseY;
        star.dataset.phase = Math.random() * Math.PI * 2;
        star.dataset.amp = 6 + Math.random() * 10;
      });
    }

    initStarPositions();
    window.addEventListener("resize", initStarPositions);

    // Pointer / mouse handling – same behavior as your original snippet
    if (window.PointerEvent) {
      card.addEventListener("pointermove", function (e) {
        if (e.pointerType !== "mouse") return;
        const rect = card.getBoundingClientRect();
        const cx = rect.left + rect.width / 2;
        const cy = rect.top + rect.height / 2;
        const x = (e.clientX - cx) / rect.width;
        const y = (e.clientY - cy) / rect.height;
        state.mx = Math.max(-0.6, Math.min(0.6, x || 0));
        state.my = Math.max(-0.6, Math.min(0.6, y || 0));
      });
    } else {
      card.addEventListener("mousemove", function (e) {
        const rect = card.getBoundingClientRect();
        const cx = rect.left + rect.width / 2;
        const cy = rect.top + rect.height / 2;
        const x = (e.clientX - cx) / rect.width;
        const y = (e.clientY - cy) / rect.height;
        state.mx = Math.max(-0.6, Math.min(0.6, x || 0));
        state.my = Math.max(-0.6, Math.min(0.6, y || 0));
      });
    }

    function animateStars() {
      state.t += 0.02;

      stars.forEach((star) => {
        const baseX = parseFloat(star.dataset.baseX) || 0;
        const baseY = parseFloat(star.dataset.baseY) || 0;
        const phase = parseFloat(star.dataset.phase) || 0;
        const amp = parseFloat(star.dataset.amp) || 0;

        const wobbleX = Math.cos(state.t + phase) * amp;
        const wobbleY = Math.sin(state.t + phase) * amp;

        const mouseX = state.mx * 18;
        const mouseY = state.my * 18;

        const dx = wobbleX + mouseX;
        const dy = wobbleY + mouseY;

        star.style.transform = `translate3d(${dx}px, ${dy}px, 0)`;
      });

      requestAnimationFrame(animateStars);
    }

    requestAnimationFrame(animateStars);
  }

  function initAll(root) {
    (root || document).querySelectorAll(".drifter-card").forEach(initCard);
  }

  // Initial page load
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  // When sections reload in the Theme Editor
  document.addEventListener("shopify:section:load", function (event) {
    initAll(event.target);
  });
})();
